// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3oWEv","amount":"Amount_amount__39exr","tip":"Amount_tip__3P3ml","tipHeader":"Amount_tipHeader__2VuRx","tipsWrap":"Amount_tipsWrap__1TIMC"};